<i *ngIf="isEnabled" class="fa fa-spinner fa-spin"></i>